export enum ReportSectionDisplayType {
	None = 1,
	HTML = 2,
	Image = 3
}